/**
 * {
	"messageType": "alertNotification",
	"notificationId": 1645222225122,
	"notificationDetails": {"errorType":"ORDER_VALIDATION","notificationType":"ERROR","TRADE_PLAN":{"type":"BASIC_TRADING_SYSTEM","id":1,"symbol":"XYZ"}},
	"status": "ORDER_MODIFICATION_OUTSIDE_TRADE_PLAN",
	"statusDetails": {"orderSymbol":"XYZ"},
	"date": "2022-02-18T17:10:26.092-0500",
	"timestamp": "1645222226092"
}

 * I cant remember off the top of my head where this comes up, but I believe it is if a user
 * tries to modify the quantity of an order not belonging to a trade plan, in which we would have to 
 * cancel the order and place a new one. I believe we block this
 * 
 * @param {} statusDetails 
 * @returns object with field:
 * 1) symbol. the symbol of the order that was attempted to be modified
 */
export function orderModificationOutsideOfTradePlanParser(statusDetails) {
  const parsedObj = {
    symbol: null,
  };
  if (statusDetails) {
    parsedObj.symbol = statusDetails.orderSymbol ?? null;
  }
  return parsedObj;
}
